<template>
  <div id="MainAttachment" class="layout-bidding-all">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card outlined
        ><v-card-title>Bidding Attachment (Without Price)</v-card-title>
        <v-card-text>
          <v-data-table
            hide-default-footer
            :headers="headers"
            :items="listWithoutPrice.filter((e) => e.docCode !== 'D009')"
            :loading="loadingProject"
            loading-text="Loading... Please wait"
            ><template v-slot:[`item.isDefault`]="{ item }">
              <v-simple-checkbox
                v-model="item.isDefault"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`item.attachFileName`]="{ item }">
              <a
                v-if="
                  checkEdit(1, isEdit)
                    ? item.attachFileName && item.isActive
                      ? true
                      : false
                    : true
                "
                class="secondary--text text-decoration-underline"
                @click="
                  getFileAtachment(item.attachFileId, item.attachFileName)
                "
                rel="noopener noreferrer"
                >{{ item.attachFileName }}</a
              >
              <div v-else class="mt-6">
                <v-file-input
                  v-if="item.isDefault"
                  label="Upload file"
                  dense
                  show-size
                  accept=".zip,.xlsx,.xls,.docx,.doc,.7z,.rar,.pdf,.dwg,.pptx,.ppt,.mpp"
                  :rules="[
                    (v) => {
                      if (!v) return 'File input is required';
                      const allowed = ['zip','xlsx','xls','docx','doc','7z','rar','pdf','dwg','pptx','ppt','mpp'];
                      const ext = v.name.split('.').pop().toLowerCase();
                      if (!allowed.includes(ext)) return `File type .${ext} not allowed`;
                      const maxSize = 31457280;
                      return v.size <= maxSize || 'File size must be less than or equal to 30MB';
                    }
                  ]"
                  required
                  :multiple="item.docCode === 'D009'"
                  truncate-length="10"
                  v-model="item.file"
                  :append-icon="item.file ? 'mdi-eye' : ''"
                  @click:append="viewFilePdf(item.file)"
                  :smallChips="item.docCode === 'D009'"
                  :counter="item.docCode === 'D009'"
                  :clearable="false"
                >
                </v-file-input
                ><v-file-input
                  v-else
                  label="Upload file"
                  dense
                  show-size
                  :multiple="item.docCode === 'D009'"
                  accept=".zip,.xlsx,.xls,.docx,.doc,.7z,.rar,.pdf,.dwg,.pptx,.ppt,.mpp"
                  :rules="[
                    (v) => {
                      if (!v) return true;
                      const allowed = ['zip','xlsx','xls','docx','doc','7z','rar','pdf','dwg','pptx','ppt','mpp'];
                      const ext = v.name.split('.').pop().toLowerCase();
                      if (!allowed.includes(ext)) return `File type .${ext} not allowed`;
                      const maxSize = 31457280;
                      return v.size <= maxSize || 'File size must be less than or equal to 30MB';
                    }
                  ]"
                  truncate-length="10"
                  v-model="item.file"
                  :append-icon="item.file ? 'mdi-eye' : ''"
                  @click:append="viewFilePdf(item.file)"
                  :smallChips="item.docCode === 'D009'"
                  :counter="item.docCode === 'D009'"
                  :clearable="false"
                >
                </v-file-input>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                :disabled="!checkEdit(1, isEdit)"
                @click="deleteItem(item)"
              >
                {{ checkEdit(1, isEdit) ? "mdi-delete" : "mdi-delete-off" }}
              </v-icon>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <v-tooltip bottom color="warning" dark>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline </v-icon>
                </template>
                {{ item.description }}
              </v-tooltip>
            </template></v-data-table
          >
          <v-divider></v-divider>
          <v-row class="mt-10 mb-4">
            <h4>Other File (Without Price)</h4>
            <v-tooltip bottom color="warning" dark>
              <template v-slot:activator="{ on }">
                <v-icon class="ml-2 mb-2" v-on="on"
                  >mdi-help-circle-outline
                </v-icon>
              </template>
              {{ descOthersWithOutPrice }}
            </v-tooltip>
            <v-spacer></v-spacer>
            <div v-if="checkEdit(1, isEdit)">
              <v-btn
                small
                @click="onButtonClickWithOutPrice"
                outlined
                color="secondary"
              >
                Add File Other
              </v-btn>
              <input
                ref="uploaderWithOutPrice"
                class="d-none"
                type="file"
                accept=".zip,.xlsx,.xls,.docx,.doc,.7z,.rar,.pdf,.dwg,.pptx,.ppt,.mpp"
                @change="onFileChangedWithOutPrice"
              />
            </div>
          </v-row>

          <v-data-table
            hide-default-footer
            :headers="headersOthers"
            :items="othersFilesWithOutPrice.filter((e) => e.isActive)"
            :loading="loadingProject"
            loading-text="Loading... Please wait"
            ><template v-slot:[`item.isDefault`]="{ item }">
              <v-simple-checkbox
                v-model="item.isDefault"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`item.attachFileName`]="{ item }">
              <a
                v-if="
                  checkEdit(1, isEdit)
                    ? item.attachFileName && item.isActive
                      ? true
                      : false
                    : true
                "
                class="secondary--text text-decoration-underline"
                @click="
                  item.isNew
                    ? viewFilePdf(item.file)
                    : getFileAtachment(item.attachFileId, item.attachFileName)
                "
                rel="noopener noreferrer"
                >{{ item.attachFileName }}</a
              >
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                :disabled="
                  checkEdit(1, isEdit)
                    ? item.attachFileName && item.isActive
                      ? false
                      : true
                    : true
                "
                @click="deleteOther(item)"
              >
                {{
                  checkEdit(1, isEdit)
                    ? item.attachFileName && item.isActive
                      ? "mdi-delete"
                      : "mdi-delete-off"
                    : "mdi-delete-off"
                }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text></v-card
      >
      <v-card outlined class="mt-4"
        ><v-card-title>Bidding Attachment (With Price)</v-card-title>
        <v-card-text>
          <v-tabs v-if="isRound > 0" v-model="isTap">
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="(item, index) in oldDataBiddingDetail" :key="index">
              {{
                index === 0
                  ? "First Submit"
                  : `Negotiation #${item.biddingRound - 1}`
              }}
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="isTap">
            <v-tab-item
              v-for="(itemBid, indexRound) in oldDataBiddingDetail"
              :key="indexRound"
            >
              <v-card flat>
                <v-card-text>
                  <v-data-table
                    hide-default-footer
                    :headers="headers"
                    :items="
                      itemBid.biddingRound === 1
                        ? listWithPrice1.filter((e) => e.docCode !== 'D010')
                        : itemBid.biddingRound === 2
                        ? listWithPrice2.filter((e) => e.docCode !== 'D010')
                        : itemBid.biddingRound === 3
                        ? listWithPrice3.filter((e) => e.docCode !== 'D010')
                        : itemBid.biddingRound === 4
                        ? listWithPrice4.filter((e) => e.docCode !== 'D010')
                        : itemBid.biddingRound === 5
                        ? listWithPrice5.filter((e) => e.docCode !== 'D010')
                        : listWithPrice6.filter((e) => e.docCode !== 'D010')
                    "
                    :loading="loadingProject"
                    loading-text="Loading... Please wait"
                    ><template v-slot:[`item.isDefault`]="{ item }">
                      <v-simple-checkbox
                        v-model="item.isDefault"
                        disabled
                      ></v-simple-checkbox>
                    </template>
                    <template v-slot:[`item.attachFileName`]="{ item }">
                      <a
                        v-if="
                          checkEdit(itemBid.biddingRound, isEdit)
                            ? item.attachFileName && item.isActive
                              ? true
                              : false
                            : true
                        "
                        class="secondary--text text-decoration-underline"
                        @click="
                          getFileAtachment(
                            item.attachFileId,
                            item.attachFileName
                          )
                        "
                        rel="noopener noreferrer"
                        >{{ item.attachFileName }}</a
                      >
                      <div v-else class="mt-6">
                        <v-file-input
                          v-if="item.isDefault"
                          label="Upload file"
                          dense
                          show-size
                          accept=".zip,.xlsx,.xls,.docx,.doc,.7z,.rar,.pdf,.dwg,.pptx,.ppt,.mpp"
                          :rules="[
                            (v) => {
                              if (!v) return 'File input is required';
                              const allowed = ['zip','xlsx','xls','docx','doc','7z','rar','pdf','dwg','pptx','ppt','mpp'];
                              const ext = v.name.split('.').pop().toLowerCase();
                              if (!allowed.includes(ext)) return `File type .${ext} not allowed`;
                              const maxSize = 31457280;
                              return v.size <= maxSize || 'File size must be less than or equal to 30MB';
                            }
                          ]"
                          required
                          truncate-length="10"
                          v-model="item.file"
                          :append-icon="item.file ? 'mdi-eye' : ''"
                          @click:append="viewFilePdf(item.file)"
                          :clearable="false"
                        >
                        </v-file-input>
                        <v-file-input
                          v-else
                          label="Upload file"
                          dense
                          show-size
                          accept=".zip,.xlsx,.xls,.docx,.doc,.7z,.rar,.pdf,.dwg,.pptx,.ppt,.mpp"
                          :rules="[
                            (v) => {
                              if (!v) return true;
                              const allowed = ['zip','xlsx','xls','docx','doc','7z','rar','pdf','dwg','pptx','ppt','mpp'];
                              const ext = v.name.split('.').pop().toLowerCase();
                              if (!allowed.includes(ext)) return `File type .${ext} not allowed`;
                              const maxSize = 31457280;
                              return v.size <= maxSize || 'File size must be less than or equal to 30MB';
                            }
                          ]"
                          truncate-length="10"
                          v-model="item.file"
                          :append-icon="item.file ? 'mdi-eye' : ''"
                          @click:append="viewFilePdf(item.file)"
                          :clearable="false"
                        >
                        </v-file-input>
                      </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        :disabled="!checkEdit(itemBid.biddingRound, isEdit)"
                        @click="deleteItem(item)"
                      >
                        {{ checkEdit(itemBid.biddingRound, isEdit) ? "mdi-delete" : "mdi-delete-off" }}
                      </v-icon>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <v-tooltip bottom color="warning" dark>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-help-circle-outline </v-icon>
                        </template>
                        {{ item.description }}
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  <v-divider></v-divider>
                  <v-row class="mt-10 mb-4">
                    <h4>Other File (With Price)</h4>
                    <v-tooltip bottom color="warning" dark>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-2 mb-2" v-on="on"
                          >mdi-help-circle-outline
                        </v-icon>
                      </template>
                      {{ descOthersWithPrice }}
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <div v-if="checkEdit(itemBid.biddingRound, isEdit)">
                      <v-btn
                        small
                        @click="onButtonClickWithPrice"
                        outlined
                        color="secondary"
                      >
                        Add File Other
                      </v-btn>
                      <input
                        ref="uploaderWithPrice"
                        class="d-none"
                        type="file"
                        accept=".zip,.xlsx,.xls,.docx,.doc,.7z,.rar,.pdf,.dwg,.pptx,.ppt,.mpp"
                        @change="onFileChangedWithPrice"
                      />
                    </div>
                  </v-row>

                  <v-data-table
                    hide-default-footer
                    :headers="headersOthers"
                    :items="
                      itemBid.biddingRound === 1
                        ? othersFilesWithPrice1.filter((e) => e.isActive)
                        : itemBid.biddingRound === 2
                        ? othersFilesWithPrice2.filter((e) => e.isActive)
                        : itemBid.biddingRound === 3
                        ? othersFilesWithPrice3.filter((e) => e.isActive)
                        : itemBid.biddingRound === 4
                        ? othersFilesWithPrice4.filter((e) => e.isActive)
                        : itemBid.biddingRound === 5
                        ? othersFilesWithPrice5.filter((e) => e.isActive)
                        : othersFilesWithPrice6.filter((e) => e.isActive)
                    "
                    :loading="loadingProject"
                    loading-text="Loading... Please wait"
                    ><template v-slot:[`item.isDefault`]="{ item }">
                      <v-simple-checkbox
                        v-model="item.isDefault"
                        disabled
                      ></v-simple-checkbox>
                    </template>
                    <template v-slot:[`item.attachFileName`]="{ item }">
                      <a
                        v-if="
                          checkEdit(itemBid.biddingRound, isEdit)
                            ? item.attachFileName && item.isActive
                              ? true
                              : false
                            : true
                        "
                        class="secondary--text text-decoration-underline"
                        @click="
                          item.isNew
                            ? viewFilePdf(item.file)
                            : getFileAtachment(
                                item.attachFileId,
                                item.attachFileName
                              )
                        "
                        rel="noopener noreferrer"
                        >{{ item.attachFileName }}</a
                      >
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        :disabled="
                          checkEdit(itemBid.biddingRound, isEdit)
                            ? item.attachFileName && item.isActive
                              ? false
                              : true
                            : true
                        "
                        @click="deleteOther(item)"
                      >
                        {{
                          checkEdit(itemBid.biddingRound, isEdit)
                            ? item.attachFileName && item.isActive
                              ? "mdi-delete"
                              : "mdi-delete-off"
                            : "mdi-delete-off"
                        }}
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card-text></v-card
              ></v-tab-item
            ></v-tabs-items
          ></v-card-text
        ></v-card
      >
      <!-- <v-btn color="success" class="mr-4" @click="validate"> Validate </v-btn>
      -->
    </v-form>
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";
import { GetBlobFileforDownload } from "../../../services/utility";
import blobToBase64 from "../../../util/img-to-base64";
import { viewFile } from "../../../util/view-file";

export default {
  name: "MainAttachment",
  props: {
    propIsVendorValid: {
      type: Boolean,
      default: false,
    },
    propIsEdit: {
      type: Boolean,
      default: false,
    },
    propBiddingIsReview: {
      type: Boolean,
      default: false,
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
    onSaveDraft: {
      type: Boolean,
      default: () => false,
    },
    propIsSaveDraftDone: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    vendorId() {
      return this.$store.state.AppActiveUser.vendorID;
    },
  },
  data() {
    return {
      marker: true,
      listWithoutPrice: [],
      listWithPrice: [],
      listWithPrice1: [],
      listWithPrice2: [],
      listWithPrice3: [],
      listWithPrice4: [],
      listWithPrice5: [],
      listWithPrice6: [],
      headers: [
        { text: "Require", value: "isDefault", width: 100 },
        { text: "Name", value: "docName" },
        { text: "File", value: "attachFileName", width: 400 },
        { text: "Remark", value: "docRemark", width: 200 },
        { text: "Delete", value: "actions", width: 100 },
        { text: "Description", value: "description", width: 100 },
      ],
      headersOthers: [
        { text: "Require", value: "isDefault", width: 100 },
        { text: "File", value: "attachFileName" },
        { text: "Delete", value: "actions", width: 100 },
      ],
      isRound: 1,
      isTap: 0,
      dataAttachments: [],
      loadingProject: false,
      valid: true,
      othersFilesWithPrice: [],
      othersFilesWithPrice1: [],
      othersFilesWithPrice2: [],
      othersFilesWithPrice3: [],
      othersFilesWithPrice4: [],
      othersFilesWithPrice5: [],
      othersFilesWithPrice6: [],
      othersFilesWithOutPrice: [],
      descOthersWithPrice: "",
      descOthersWithOutPrice: "",
      isEdit: false,
      oldDataBiddingDetail: [],
    };
  },
  mounted() {
    this.isEdit = this.propIsEdit;
    //this.getProjectDetail();
  },
  watch: {
    propCheckStep(value) {
      if (value === 3) {
        this.validate();
      }
      if (value === 2) {
        if (this.propIsEdit) {
          if (this.propIsSaveDraftDone) {
            this.getDocument();
          }
        } else {
          this.getDocument();
        }
      }
    },
    onSaveDraft(value) {
      if (value) {
        this.validate();
      }
    },
    propIsEdit(value) {
      this.isEdit = value;
    },
    propIsSaveDraftDone(value) {
      if (value) {
        if (this.propCheckStep === 2) {
          this.getDocument();
        }
      }
    },
  },
  methods: {
    async validate() {
      this.$loading(true);
      this.isTap = this.isRound - 1;
      setTimeout(() => {
        this.$loading(false);
        this.$refs.form.validate();
      }, 1000);
      setTimeout(() => {
        if (this.valid === true) {
          if (this.isEdit) {
            this.setModel();
          } else {
            this.$emit("emitSubmitAttachmentStep3Next", true);
          }
        } else {
          this.$emit("emitSubmitAttachmentStep3Next", false);
        }
      }, 1500);
    },
    checkEdit(isRound, isEdit) {
      const round = this.isRound === isRound ? true : false;
      if (round && isEdit) return true;
      else return false;
    },
    getListWithPrice() {
      if (this.dataAttachments.length > 0) {
        for (let i = 0; i < this.dataAttachments.length; i++) {
          const round = this.dataAttachments[i].round;
          const listAttachment = this.dataAttachments[i].listAttachment;
          for (let i = 0; i < this[`listWithPrice${round}`].length; i++) {
            const result = listAttachment.filter(
              (element) => element.docCode === "D010"
            );
            if (result.length > 0) {
              for (let k = 0; k < result.length; k++) {
                result[k].isNew = false;
              }
            }
            this[`othersFilesWithPrice${round}`] = result;
            const foundDoc = listAttachment.find(
              (element) =>
                element.docCode === this[`listWithPrice${round}`][i].docCode
            );
            if (foundDoc) {
              if (foundDoc.docCode !== "D010") {
                this[`listWithPrice${round}`][i] = {
                  ...foundDoc,
                  docRemark: this[`listWithPrice${round}`][i].docRemark,
                };
              }
            }
          }
        }
      }
    },
    async getAttachments() {
      const result = await _projectservice.GetLastSubmitAttachmentRow(
        this.$route.params.projectId,
        this.vendorId
      );
      return result;
    },
    async getDocument() {
      this.loadingProject = true;
      const doc = await _projectservice.GetBiddingProjectDocumentByProjectId(
        this.$route.params.projectId
      );
      const resultOldDetail = await _projectservice.GetBiddingDetail(
        this.$route.params.projectId,
        this.vendorId
      );
      this.oldDataBiddingDetail = resultOldDetail;
      const resultAttachment = await _projectservice.GetLastSubmitAttachmentRow(
        this.$route.params.projectId,
        this.vendorId
      );
      this.dataAttachments = await resultAttachment;

      console.log("doic", doc);

      let WithoutPrice = [];
      let WithPrice = [];
      if (doc.length > 0) {
        for (let i = 0; i < doc.length; i++) {
          if (doc[i].docType === "Without Price") {
            if (doc[i].docCode === "D009") {
              this.descOthersWithOutPrice = doc[i].description;
            }
            WithoutPrice.push(doc[i]);
          }
          if (doc[i].docType === "With Price") {
            if (doc[i].docCode === "D010") {
              this.descOthersWithPrice = doc[i].description;
            }
            WithPrice.push(doc[i]);
          }
        }
      }
      this.isRound =
        resultOldDetail.length === 0
          ? 1
          : resultOldDetail[resultOldDetail.length - 1].biddingRound;

      this.listWithoutPrice = WithoutPrice;
      this.listWithPrice = WithPrice;
      if (this.isRound) {
        for (let i = 0; i < this.isRound; i++) {
          this[`listWithPrice${i + 1}`] = [...WithPrice];
        }
      }
      if (resultOldDetail.length > 0) {
        for (let i = 0; i < resultOldDetail.length; i++) {
          this[`listWithPrice${i + 1}`] = [...WithPrice];
          this.getListWithPrice(i);
        }
      }

      if (this.dataAttachments.length > 0) {
        const listAttachment = this.dataAttachments[0].listAttachment;
        for (let i = 0; i < this.listWithoutPrice.length; i++) {
          const foundDoc = listAttachment.find(
            (element) => element.docCode === this.listWithoutPrice[i].docCode
          );
          if (foundDoc) {
            if (foundDoc.docCode === "D009") {
              foundDoc.isNew = false;
              this.othersFilesWithOutPrice.push(foundDoc);
            } else {
              this.listWithoutPrice[i] = {
                ...foundDoc,
                docRemark: this.listWithoutPrice[i].docRemark,
              };
            }
          }
        }
        const result = this.dataAttachments[0].listAttachment.filter(
          (element) => element.docCode === "D009"
        );
        if (result.length > 0) {
          for (let k = 0; k < result.length; k++) {
            result[k].isNew = false;
          }
        }
        this.othersFilesWithOutPrice = result;
      }
      this.loadingProject = false;
    },
    async getFileAtachment(fileSystemName, fileRealName) {
      this.$loading(true);
      await _projectservice.GetBlobFileVendor(fileSystemName, fileRealName);
      this.$loading(false);
    },
    async viewFilePdf(file) {
      await viewFile(file);
    },
    // Download proposal for upload
    async downloadProposalVendorBidding(round) {
      this.progressBar = true;

      const payload = {
        projectId: parseInt(this.$route.params.projectId),
        vendorId: this.$store.state.AppActiveUser.vendorID,
        biddingRound: round,
      };

      var fileObj = await _projectservice.DownloadProposalVendorBidding(
        payload
      );
      // Download file proposal
      GetBlobFileforDownload(fileObj);
      this.progressBar = false;
      this.callBackAttachmentToMain();
    },
    async setModel() {
      let listAttachment = [];
      //listWithoutPrice
      for (let i = 0; i < this.listWithoutPrice.length; i++) {
        if (this.listWithoutPrice[i].file) {
          const body = {
            projectVendorSubmitAttachRowId: this.listWithoutPrice[i]
              .projectVendorSubmitAttachRowId
              ? this.listWithoutPrice[i].projectVendorSubmitAttachRowId
              : 0,
            docCode: this.listWithoutPrice[i].docCode,
            docType: this.listWithoutPrice[i].docType,
            attachFileBase64: await this.setBase64(
              this.listWithoutPrice[i].file
            ),
            attachFileName: this.listWithoutPrice[i].file.name,
            isActive: true,
          };
          listAttachment.push(body);
        } else {
          if (this.listWithoutPrice[i].isDelete) {
            const body = {
              projectVendorSubmitAttachRowId: this.listWithoutPrice[i]
                .projectVendorSubmitAttachRowId
                ? this.listWithoutPrice[i].projectVendorSubmitAttachRowId
                : 0,
              docCode: this.listWithoutPrice[i].docCode,
              docType: this.listWithoutPrice[i].docType,
              isActive: false,
            };
            listAttachment.push(body);
          }
        }
      }
      //listWithPrice
      const r = this.isRound;
      for (let i = 0; i < this[`listWithPrice${r}`].length; i++) {
        if (this[`listWithPrice${r}`][i].file) {
          const body = {
            projectVendorSubmitAttachRowId: this[`listWithPrice${r}`][i]
              .projectVendorSubmitAttachRowId
              ? this[`listWithPrice${r}`][i].projectVendorSubmitAttachRowId
              : 0,
            docCode: this[`listWithPrice${r}`][i].docCode,
            docType: this[`listWithPrice${r}`][i].docType,
            attachFileBase64: await this.setBase64(
              this[`listWithPrice${r}`][i].file
            ),
            attachFileName: this[`listWithPrice${r}`][i].file.name,
            isActive: true,
          };
          listAttachment.push(body);
        } else {
          if (this[`listWithPrice${r}`][i].isDelete) {
            const body = {
              projectVendorSubmitAttachRowId: this[`listWithPrice${r}`][i]
                .projectVendorSubmitAttachRowId
                ? this[`listWithPrice${r}`][i].projectVendorSubmitAttachRowId
                : 0,
              docCode: this[`listWithPrice${r}`][i].docCode,
              docType: this[`listWithPrice${r}`][i].docType,
              isActive: false,
            };
            listAttachment.push(body);
          }
        }
      }
      //othersFilesWithOut
      if (this.othersFilesWithOutPrice.length > 0) {
        for (let j = 0; j < this.othersFilesWithOutPrice.length; j++) {
          if (this.othersFilesWithOutPrice[j].isNew) {
            const file = this.othersFilesWithOutPrice[j].file;
            const body = {
              projectVendorSubmitAttachRowId: this.othersFilesWithOutPrice[j]
                .projectVendorSubmitAttachRowId
                ? this.othersFilesWithOutPrice[j].projectVendorSubmitAttachRowId
                : 0,
              docCode: this.othersFilesWithOutPrice[j].docCode,
              docType: this.othersFilesWithOutPrice[j].docType,
              attachFileBase64: await this.setBase64(file),
              attachFileName: file.name,
              isActive: true,
            };
            listAttachment.push(body);
          } else {
            if (this.othersFilesWithOutPrice[j].isDelete) {
              const body = {
                projectVendorSubmitAttachRowId: this.othersFilesWithOutPrice[j]
                  .projectVendorSubmitAttachRowId
                  ? this.othersFilesWithOutPrice[j]
                      .projectVendorSubmitAttachRowId
                  : 0,
                docCode: this.othersFilesWithOutPrice[j].docCode,
                docType: this.othersFilesWithOutPrice[j].docType,
                isActive: false,
              };
              listAttachment.push(body);
            }
          }
        }
      }
      //othersFilesWithPrice
      if (this[`othersFilesWithPrice${r}`].length > 0) {
        for (let j = 0; j < this[`othersFilesWithPrice${r}`].length; j++) {
          if (this[`othersFilesWithPrice${r}`][j].isNew) {
            const file = this[`othersFilesWithPrice${r}`][j].file;
            const body = {
              projectVendorSubmitAttachRowId: this[`othersFilesWithPrice${r}`][
                j
              ].projectVendorSubmitAttachRowId
                ? this[`othersFilesWithPrice${r}`][j]
                    .projectVendorSubmitAttachRowId
                : 0,
              docCode: this[`othersFilesWithPrice${r}`][j].docCode,
              docType: this[`othersFilesWithPrice${r}`][j].docType,
              attachFileBase64: await this.setBase64(file),
              attachFileName: file.name,
              isActive: true,
            };
            listAttachment.push(body);
          } else {
            if (this[`othersFilesWithPrice${r}`][j].isDelete) {
              const body = {
                projectVendorSubmitAttachRowId: this[
                  `othersFilesWithPrice${r}`
                ][j].projectVendorSubmitAttachRowId
                  ? this[`othersFilesWithPrice${r}`][j]
                      .projectVendorSubmitAttachRowId
                  : 0,
                docCode: this[`othersFilesWithPrice${r}`][j].docCode,
                docType: this[`othersFilesWithPrice${r}`][j].docType,
                isActive: false,
              };
              listAttachment.push(body);
            }
          }
        }
      }

      const mapBody = {
        projectVendorSubmitAttachId:
          this.dataAttachments.length >= this.isRound
            ? this.dataAttachments[this.dataAttachments.length - 1]
                .projectVendorSubmitAttachId
            : 0,
        projectId: +this.$route.params.projectId,
        vendorId: this.vendorId,
        round: this.isRound,
        listAttachment: listAttachment,
      };
      await this.SubmitUploadFile(mapBody);
    },
    async setBase64(file) {
      const blob = await blobToBase64(file);
      const blobBase = blob.split(",");
      return blobBase[1];
    },
    async SubmitUploadFile(body) {
      this.$loading(true);
      try {
        let result = await _projectservice.SubmitUploadFileRow(body);
        if (result.message === undefined || result.lenght == 0) {
          this.$notify({
            type: "success",
            title: "Save Bidding Attachment Success.",
            text: "Your attachment have been saved.",
          });
          this.$emit("emitSubmitAttachmentStep3Next", true);
          this.$loading(false);
        } else {
          this.$notify({
            type: "error",
            title: "Can't Save Bidding Attachment",
            text: result.message,
          });
          this.$emit("emitSubmitAttachmentStep3Next", false);
          this.$loading(false);
        }
      } catch (error) {
        this.$notify({
          type: "error",
          title: "Can't Save Bidding Attachment",
          text: "System : [" + error + "]",
        });
        this.$emit("emitSubmitAttachmentStep3Next", false);
        this.$loading(false);
      }
    },
    deleteItem(item) {
      item.file = null;
      if (item.docType === "With Price") {
        const index = this[`listWithPrice${this.isRound}`].findIndex(
          (element) => element.docCode === item.docCode
        );
        this[`listWithPrice${this.isRound}`][index].isActive = false;
        this[`listWithPrice${this.isRound}`][index].isDelete = true;
      }
      if (item.docType === "Without Price") {
        const index = this.listWithoutPrice.findIndex(
          (element) => element.docCode === item.docCode
        );
        this.listWithoutPrice[index].isActive = false;
        this.listWithoutPrice[index].isDelete = true;
      }
    },
    onFileChangedWithPrice(e) {
      const file = e.target.files[0];

      const allowedExtensions = ["zip","xlsx","xls","docx","doc","7z","rar","pdf","dwg","pptx","ppt","mpp"];
      const maxSize = 31457280;

      if (!allowedExtensions.includes(file.name.split('.').pop().toLowerCase())) {
        this.$notify({
          type: "error",
          title: "Invalid File Type",
          text: `File type .${file.name.split('.').pop().toLowerCase()} not allowed`,
        });
        return;
      }

      if (file.size > maxSize) {
        this.$notify({
          type: "error",
          title: "File Size Exceeded",
          text: "File size must be less than or equal to 30MB",
        });
        return;
      }

      const body = {
        projectVendorSubmitAttachRowId: 0,
        docCode: "D010",
        docType: "With Price",
        attachFileName: file.name,
        isActive: true,
        isNew: true,
        file: file,
      };

      this[`othersFilesWithPrice${this.isRound}`].push(body);
    },
    onFileChangedWithOutPrice(e) {
      const file = e.target.files[0];

      const allowedExtensions = ["zip","xlsx","xls","docx","doc","7z","rar","pdf","dwg","pptx","ppt","mpp"];
      const maxSize = 31457280;

      if (!allowedExtensions.includes(file.name.split('.').pop().toLowerCase())) {
        this.$notify({
          type: "error",
          title: "Invalid File Type",
          text: `File type .${file.name.split('.').pop().toLowerCase()} not allowed`,
        });
        return;
      }

      if (file.size > maxSize) {
        this.$notify({
          type: "error",
          title: "File Size Exceeded",
          text: "File size must be less than or equal to 30MB",
        });
        return;
      }

      const body = {
        projectVendorSubmitAttachRowId: 0,
        docCode: "D009",
        docType: "Without Price",
        attachFileName: file.name,
        isActive: true,
        isNew: true,
        file: file,
      };

      this.othersFilesWithOutPrice.push(body);

      // do something
    },
    onButtonClickWithPrice() {
      window.addEventListener("focus", () => {}, { once: true });
      this.$refs.uploaderWithPrice[0].click();
    },
    onButtonClickWithOutPrice() {
      window.addEventListener("focus", () => {}, { once: true });
      this.$refs.uploaderWithOutPrice.click();
    },
    deleteOther(item) {
      if (item.docType === "With Price") {
        if (!item.isNew) {
          item.isActive = false;
          item.isDelete = true;
        } else {
          let ind = this[`othersFilesWithPrice${this.isRound}`].indexOf(item);
          this[`othersFilesWithPrice${this.isRound}`].splice(ind, 1);
        }
      } else {
        if (!item.isNew) {
          item.isActive = false;
          item.isDelete = true;
        } else {
          let ind = this.othersFilesWithOutPrice.indexOf(item);
          this.othersFilesWithOutPrice.splice(ind, 1);
        }
      }
    },
  },
};
</script>

<style></style>
